"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mobileWidgetInputStyles = exports.mobileDefaultControlStyles = exports.leftBorder = exports.StyledForm = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _formik = require("formik");

var _constants = require("./constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledForm = (0, _styledComponents["default"])(_formik.Form).withConfig({
  displayName: "styles__StyledForm",
  componentId: "sc-19r3xi2-0"
})(["", ";z-index:3;display:flex;flex-direction:", ";", ";width:100%;height:auto;", " background-color:", ";border-radius:var(--border-radius);gap:", ";", ";", " ", " ", ""], function (_ref) {
  var $isMobile = _ref.$isMobile;
  return !$isMobile && "position: relative";
}, function (_ref2) {
  var $isMobile = _ref2.$isMobile;
  return $isMobile ? 'column' : 'row';
}, function (_ref3) {
  var $isWizard = _ref3.$isWizard;
  return !$isWizard && "align-items: center";
}, function (_ref4) {
  var $variant = _ref4.$variant;
  return $variant !== 'hotel' ? 'margin: 0 auto;' : '';
}, function (_ref5) {
  var $isMobile = _ref5.$isMobile,
      $isWizard = _ref5.$isWizard,
      $variant = _ref5.$variant,
      $isWhiteLabel = _ref5.$isWhiteLabel;
  if ($isWhiteLabel) return 'var(--black)';else if ($isMobile && !$isWizard && $variant !== 'hotel') return 'var(--lime)';
  return 'var(--white)';
}, function (_ref6) {
  var $isMobile = _ref6.$isMobile,
      $isWizard = _ref6.$isWizard;
  return $isMobile && !$isWizard ? '8px' : '0';
}, function (_ref7) {
  var $isMobile = _ref7.$isMobile,
      $isWizard = _ref7.$isWizard,
      $variant = _ref7.$variant;
  return $isMobile && !$isWizard && $variant !== 'hotel' && 'padding: 8px;';
}, function (_ref8) {
  var $isWizardOpen = _ref8.$isWizardOpen;
  return $isWizardOpen && (0, _styledComponents.css)(["align-items:flex-start;position:fixed;top:0;left:0;"]);
}, function (_ref9) {
  var $isMobile = _ref9.$isMobile;
  return !$isMobile && (0, _styledComponents.css)([".", " + .", "{", "}"], _constants.LEFT_BORDER_CLASS, _constants.LEFT_BORDER_CLASS, leftBorder);
}, function (_ref10) {
  var $searchType = _ref10.$searchType,
      $variant = _ref10.$variant,
      $isMobile = _ref10.$isMobile;
  return $variant === 'hotel' && !$isMobile && (0, _styledComponents.css)([".cigarette__field-border #start{border-radius:var(--border-radius) 0 0 var(--border-radius);}> .cigarette__field-border{width:", "px !important;max-width:", "px !important;}> :first-child{width:", "px !important;}"], $searchType === 'hotel' ? '400' : '300', $searchType === 'hotel' ? '400' : '300', $searchType === 'hotel' ? '800' : '600');
});
exports.StyledForm = StyledForm;
var mobileDefaultControlStyles = (0, _styledComponents.css)(["font-size:16px;line-height:20px;font-weight:400;height:48px;border-radius:var(--border-radius);padding:8px;"]);
exports.mobileDefaultControlStyles = mobileDefaultControlStyles;
var leftBorder = (0, _styledComponents.css)(["&:before{content:'';position:absolute;width:1px;height:40px;background-color:#e6e9ee;left:0;top:0;bottom:0;margin:auto;z-index:1;}"]);
exports.leftBorder = leftBorder;
var mobileWidgetInputStyles = (0, _styledComponents.css)(["input{left:0;top:0;width:100%;height:100%;transform:none;}"]);
exports.mobileWidgetInputStyles = mobileWidgetInputStyles;